<template>
  <main class="">
    <elNavbar />
    <section class="bg-light main-section">
      <div class="container py-4 mt-2">
        <div class="row align-items-center justify-content-between">
          <div class="contact-header col-12 col-md-7">
            <h1 class="h2 pb-3 text-primary">Cookies Policy</h1>
            <p class="light-300">
              TODO: Add Text Do you have any question or comment about the App?
              <br />Do you face any issue using the App?
              <br />
              <br />Then, do not hesitate to contact us; we will be happy to
              hear from you! <br />You can send an email with your query using
              the following form, or write to
              <a href="mailto:info@newabc.eu" class="" title="Send us Email"
                >info@newabc.eu</a
              >
            </p>
          </div>
          <div class="contact-img col-12 col-md-5">
            <img
              :src="
                $store.state.config.frontpoint +
                '/storage/Privacy-policy-amico.png'
              "
              class="img-fluid"
            />
          </div>
        </div>
      </div>
      <div class="container py-4">
        <div class="mt-1 mb-2">
          <h2 class="title">Cookies Policy</h2>
        </div>
        <article class="mt-4">
          <p>Last updated: December 28, 2021</p>
          <p>
            This Cookies Policy explains what Cookies are and how We use them.
            You should read this policy so You can understand what type of
            cookies We use, or the information We collect using Cookies and how
            that information is used. This Cookies Policy has been created with
            the help of the
            <a
              href="https://www.freeprivacypolicy.com/free-cookies-policy-generator/"
              target="_blank"
              >Cookies Policy Generator</a
            >.
          </p>

          <p>
            Cookies do not typically contain any information that personally
            identifies a user, but personal information that we store about You
            may be linked to the information stored in and obtained from
            Cookies. For further information on how We use, store and keep your
            personal data secure, see our Privacy Policy.
          </p>
          <p>
            We do not store sensitive personal information, such as mailing
            addresses, account passwords, etc. in the Cookies We use.
          </p>
        </article>
        <strong class="h2 my-4">The use of the Cookies</strong>
        <article class="mt-4">
          <h3>Type of Cookies We Use</h3>
          <p>
            Cookies can be &quot;Persistent&quot; or &quot;Session&quot;
            Cookies. Persistent Cookies remain on your personal computer or
            mobile device when You go offline, while Session Cookies are deleted
            as soon as You close your web browser.
          </p>
          <p>
            We use both session and persistent Cookies for the purposes set out
            below:
          </p>
          <ul>
            <li>
              <p><strong>Necessary / Essential Cookies</strong></p>
              <p>Type: Session Cookies</p>
              <p>Administered by: Us</p>
              <p>
                Purpose: These Cookies are essential to provide You with
                services available through the Website and to enable You to use
                some of its features. They help to authenticate users and
                prevent fraudulent use of user accounts. Without these Cookies,
                the services that You have asked for cannot be provided, and We
                only use these Cookies to provide You with those services.
              </p>
            </li>
            <li>
              <p><strong>Functionality Cookies</strong></p>
              <p>Type: Persistent Cookies</p>
              <p>Administered by: Us</p>
              <p>
                Purpose: These Cookies allow us to remember choices You make
                when You use the Website, such as remembering your login details
                or language preference. The purpose of these Cookies is to
                provide You with a more personal experience and to avoid You
                having to re-enter your preferences every time You use the
                Website.
              </p>
            </li>
          </ul>
        </article>
        <article class="mt-4">
          <h3>Your Choices Regarding Cookies</h3>
          <p>
            If You prefer to avoid the use of Cookies on the Website, first You
            must disable the use of Cookies in your browser and then delete the
            Cookies saved in your browser associated with this website. You may
            use this option for preventing the use of Cookies at any time.
          </p>
          <p>
            If You do not accept Our Cookies, You may experience some
            inconvenience in your use of the Website and some features may not
            function properly.
          </p>
          <p>
            If You'd like to delete Cookies or instruct your web browser to
            delete or refuse Cookies, please visit the help pages of your web
            browser.
          </p>
          <ul>
            <li>
              <p>
                For the Chrome web browser, please visit this page from Google:
                <a
                  href="https://support.google.com/accounts/answer/32050"
                  rel="external nofollow noopener"
                  target="_blank"
                  >https://support.google.com/accounts/answer/32050</a
                >
              </p>
            </li>
            <li>
              <p>
                For the Internet Explorer web browser, please visit this page
                from Microsoft:
                <a
                  href="http://support.microsoft.com/kb/278835"
                  rel="external nofollow noopener"
                  target="_blank"
                  >http://support.microsoft.com/kb/278835</a
                >
              </p>
            </li>
            <li>
              <p>
                For the Firefox web browser, please visit this page from
                Mozilla:
                <a
                  href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored"
                  rel="external nofollow noopener"
                  target="_blank"
                  >https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored</a
                >
              </p>
            </li>
            <li>
              <p>
                For the Safari web browser, please visit this page from Apple:
                <a
                  href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                  rel="external nofollow noopener"
                  target="_blank"
                  >https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a
                >
              </p>
            </li>
          </ul>
          <p>
            For any other web browser, please visit your web browser's official
            web pages.
          </p>
        </article>
        <article class="mt-4">
          <h3>More Information about Cookies</h3>
          <p>
            You can learn more about cookies:
            <a
              href="https://www.freeprivacypolicy.com/blog/cookies/"
              target="_blank"
              >Cookies: What Do They Do?</a
            >.
          </p>
        </article>
        <article class="mt-4">
          <h3>Contact Us</h3>
          <p>
            If you have any questions about this Cookies Policy, You can contact
            us:
          </p>
          <ul>
            <li>By email: contact@alwelhost.com</li>
          </ul>
        </article>

        <hr />
        <a href="https://www.freepik.com/">
          Photo created by rawpixel.com - www.freepik.com
        </a>
      </div>
    </section>
    <elFooter />
  </main>
</template>

<script>
import elFooter from "../components/Footer.vue";
import elNavbar from "../components/Navbar.vue";

export default {
  name: "CookiesPolicy",
  metaInfo: {
    title: "Cookies Policy",
    titleTemplate: "%s | NEW ABC APP",
  },
  components: {
    elFooter,
    elNavbar,
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>
